export enum Routes {
  CalculationRouter = "*",
  CalculationSearchPageRouter = "/calculation/search",
  CalculationDetailPageRouter = '/calculation/detail/:calculationId',
  CalculationResultPageRouter = '/calculation/result/:calculationId',

  CalculationSettingPageRouter = '/calculation/setting/detail',

  CalculationAnnualTaxSearchPageRouter = '/calculation/setting/annual-tax',
  CalculationAnnualTaxCreatePageRouter = "/calculation/setting/annual-tax/create",
  CalculationAnnualTaxEditPageRouter = '/calculation/setting/annual-tax/:annualTaxId?',
  CalculationAnnualTaxDetailPageRouter = '/calculation/setting/annual-tax/detail/:annualTaxId',

  CalculationLeasingSearchPageRouter = '/calculation/setting/leasing',
  CalculationLeasingCreatePageRouter = "/calculation/setting/leasing/create",
  CalculationLeasingEditPageRouter = '/calculation/setting/leasing/:leasingId?',
  CalculationLeasingDetailPageRouter = '/calculation/setting/leasing/detail/:leasingId',

  CalculationResidualValueSearchPageRouter = '/calculation/setting/residual-value',
  CalculationResidualValueCreatePageRouter = "/calculation/setting/residual-value/create",
  CalculationResidualValueEditPageRouter = '/calculation/setting/residual-value/:residualValueId?',
  CalculationResidualValueDetailPageRouter = '/calculation/setting/residual-value/detail/:residualValueId',

  CalculationTireSearchPageRouter = '/calculation/setting/tire',
  CalculationTireCreatePageRouter = "/calculation/setting/tire/create",
  CalculationTireEditPageRouter = '/calculation/setting/tire/:tireId?',
  CalculationTireDetailPageRouter = '/calculation/setting/tire/detail/:tireId',

  CalculationVehicleGroupSearchPageRouter = '/calculation/setting/vehicle-group',
  CalculationVehicleGroupCreatePageRouter = "/calculation/setting/vehicle-group/create",
  CalculationVehicleGroupEditPageRouter = '/calculation/setting/vehicle-group/:vehicleGroupId?',
  CalculationVehicleGroupDetailPageRouter = '/calculation/setting/vehicle-group/detail/:vehicleGroupId',

  CalculationTehnicalInspectionSearchPageRouter = '/calculation/setting/tehnical-inspection',
  CalculationTehnicalInspectionCreatePageRouter = "/calculation/setting/tehnical-inspection/create",
  CalculationTehnicalInspectionEditPageRouter = '/calculation/setting/tehnical-inspection/:tehnicalInspectionId?',
  CalculationTehnicalInspectionDetailPageRouter = '/calculation/setting/tehnical-inspection/detail/:tehnicalInspectionId',

  CalculationVehicleInsuranceSearchPageRouter = '/calculation/setting/vehicle-insurance',
  CalculationVehicleInsuranceCreatePageRouter = "/calculation/setting/vehicle-insurance/create",
  CalculationVehicleInsuranceEditPageRouter = '/calculation/setting/vehicle-insurance/:vehicleInsuranceId?',
  CalculationVehicleInsuranceDetailPageRouter = '/calculation/setting/vehicle-insurance/detail/:vehicleInsuranceId',

  CalculationTollSearchPageRouter = '/calculation/setting/toll',
  CalculationTollCreatePageRouter = "/calculation/setting/toll/create",
  CalculationTollEditPageRouter = '/calculation/setting/toll/:tollId?',
  CalculationTollDetailPageRouter = '/calculation/setting/toll/detail/:tollId',

  CalculationVehicleServicesSearchPageRouter = '/calculation/setting/vehicle-services',
  CalculationVehicleServicesCreatePageRouter = "/calculation/setting/vehicle-services/create",
  CalculationVehicleServicesEditPageRouter = '/calculation/setting/vehicle-services/:vehicleServicesId?',
  CalculationVehicleServicesDetailPageRouter = '/calculation/setting/vehicle-services/detail/:vehicleServicesId',
}
